import './Tab.a5260d09ed62d46a019ad63c9509a01b.css';
export default {"tabList":"_tabList_15s8v_1","scrollable":"_scrollable_15s8v_1","item":"_item_15s8v_1","active":"_active_15s8v_1","hidden":"_hidden_15s8v_1"};